module.exports = __webpack_public_path__ + "img/252.675e947e.jpg";